module.exports = __webpack_public_path__ + "img/development-during-recession-top.16e1baf4.jpg";